import { sendEzspmByLink } from "tyrande";
import { tryDecodeURIComponent } from "./browser/uri";

export interface PrmParams {
	floor: number;
	position?: number;
}

export const sendPrmByUrl = (link: string = "") => {
	if (!link.startsWith("#")) {
		sendEzspmByLink(tryDecodeURIComponent(link), false);
	}
};
